import React from "react";

import { useState, useEffect } from "react";

import IKUN from "../assets/ikun.gif";

import Darklogo from "./Darklogo";

import { useNavigate } from "react-router-dom";

import SideDrawerMenu from "./SideDrawerMenu";

import { FiMenu, FiX } from "react-icons/fi";

import  Logo  from "../components/Logo"; // 引入你的 logo 图片

const Header = ({ toggleDarkMode, isDarkMode }) => {
  const [showLogoAnim, setShowLogoAnim] = useState(false); // 加载小太阳
  const [isHovered, setIsHovered] = useState(false); // 添加 hover 状态
  const navigate = useNavigate();

  useEffect(() => {
    setShowLogoAnim(true);
  }, []);

  const [drawerOpen, setDrawerOpen] = useState(false); // ✅ 控制 Drawer 状态

  return (
    <header className="fixed top-0 left-0 w-full py-8 z-50">
      <div className="relative mx-auto px-4 flex justify-between items-center lg:px-12 xl:px-20">
        {/* 左边 LOGO */}
        <div className="absolute top-0 flex items-center left-[40px]">
          <button onClick={() => navigate("/")}>
            <Logo isDarkMode={isDarkMode} className="w-[40px] h-[40px]" />
          </button>
        </div>

        {/* 右上角区域 */}
        <div className="absolute top-[20px] right-[20px] flex items-center gap-x-4 h-full">
          {/* 小太阳按钮 */}
          <button 
            onClick={toggleDarkMode} 
            className="rounded hover:scale-110 transition-transform duration-300"
          >
            <Darklogo
              className="w-[40px] h-[40px]"
              isDark={isDarkMode}
              show={showLogoAnim}
              isHovered={isHovered}
              setIsHovered={setIsHovered}
            />
          </button>

          {/* 右边菜单按钮 */}
          {/* 自定义菜单按钮 ✅ */}
          <div className="z-[1000] h-full flex items-center">
            <button
              onClick={() => setDrawerOpen(!drawerOpen)}
              className="w-10 h-10 relative z-[9999] flex flex-col justify-center items-center opacity-50 hover:opacity-100 duration-300 ease-in-out"
            >
              <span
                className={`block absolute h-1.5 w-8 bg-current transform transition duration-300 ease-in-out ${
                  drawerOpen
                    ? "rotate-45 top-[14px] right-[3px]"
                    : "-translate-y-2"
                }`}
              />
              <span
                className={`block absolute h-1.5 w-8 bg-current transform transition duration-300 ease-in-out ${
                  drawerOpen ? "-rotate-45 bottom-[20px]" : "translate-y-2"
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* ✅ 抽屉组件插入 */}
      <SideDrawerMenu open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </header>
  );
};

export default Header;
